import { createContext, useContext, useState, useEffect } from 'react';
import { Encrypt, Decrypt } from '../../../utils';

const DataContext = createContext();

export function useDataContext() {
    return useContext(DataContext);
}

export function DataProvider({ children }) {
    const decryptedClaimsData =
        localStorage.getItem('claimsData') !== null ? JSON.parse(Decrypt(localStorage.getItem('claimsData'))) : {};

    const [claimsData, setClaimsData] = useState({});

    const updateClaimsData = (newData) => {
        const updatedData = {
            ...decryptedClaimsData,
            ...newData
        };
        const encryptedData = Encrypt(updatedData);
        setClaimsData(encryptedData);
        localStorage.setItem('claimsData', encryptedData);
    };

    const clearClaimsData = () => {
        setClaimsData({});
        localStorage.removeItem('claimsData');
    };
    console.log('decryptedClaimsData: ', decryptedClaimsData);

    return (
        <DataContext.Provider
            value={{
                claimsData: decryptedClaimsData,
                updateClaimsData,
                clearClaimsData
            }}
        >
            {children}
        </DataContext.Provider>
    );
}
